<script lang="ts" setup>
import { computed, type PropType, toRef } from 'vue'

import { useShipStore } from '@/stores/ship'
import { storeToRefs } from 'pinia'

import type { ShipType } from '@/stores/type/ship.type'
import ShipParameterTable from '@/components/ship-importer/ShipParameterTable.vue'

const shipStore = useShipStore()

const { options, selectedItems } = storeToRefs(shipStore)

const props = defineProps({
  item: { type: Object as PropType<ShipType>, required: true }
})

const item = toRef(props, 'item')

const KEY: (keyof ShipType)[] = [
  'name',
  'length_overall',
  'breadth',
  'main_engine_power',
  'rudder',
  'main_engine_type',
  'transverse_thruster_power',
  'transverse_thruster_type'
]

const getChoices = (key: keyof ShipType) => {
  return options.value.actions.POST[key]?.choices ?? []
}

const getValue = (key: keyof ShipType): string => {
  const choiceField = ['rudder', 'main_engine_type', 'transverse_thruster_type']
  if (choiceField.includes(key)) {
    return getChoices(key).find((choice) => choice.value === item.value[key])?.display_name ?? ''
  }
  return item.value[key] as string
}

const isSelected = computed<boolean>({
  get: () => selectedItems.value?.includes(item.value) || false,
  set: (value) => {
    shipStore.updateSelectedItems(value, [item.value])
  }
})

const open = ref(false)

function toggleOpen(): void {
  if (item.value) {
    open.value = !open.value
  }
}

const handleChangeShip = (): void => {
  if (item.value) {
    shipStore.setCurrentItem(item.value)
    shipStore.openCreateUpdateDialog()
  }
}
</script>

<template>
  <tr v-if="item" v-ripple>
    <td>
      <v-checkbox v-model="isSelected" density="compact" hide-details @click.stop="" />
    </td>
    <td v-for="key in KEY" :key="key" :class="key === 'name' ? '' : 'text-center'">
      {{ getValue(key) }}
    </td>
    <td v-if="shipStore.canChangeShip" class="text-center">
      <v-btn variant="text" :icon="'$edit'" @click.stop="handleChangeShip" />
    </td>
    <td>
      <v-btn
        :icon="open ? `mdi-chevron-up` : `mdi-chevron-right`"
        size="40"
        class="my-1"
        variant="text"
        @click.stop="toggleOpen"
      >
      </v-btn>
    </td>
  </tr>
  <tr v-if="item" class="tr--no-hover">
    <td v-if="open" class="pl-0 pr-0" colspan="999" @click.stop="">
      <ShipParameterTable :ship="item" :fields="shipStore.fields"></ShipParameterTable>
    </td>
  </tr>
</template>
